import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import { DataResidencyBanner } from '@mc-prime/einstein-ui-components';
import {
  WelcomeMat,
  WelcomeMatTile,
  Icon,
  Button,
  Checkbox
} from '@salesforce/design-system-react';
import getStackUrl from '../../utilities/getStackUrl';
import './ExperimentWelcomeMat.scss';

export class ExperimentWelcomeMat extends Component {
  componentDidMount() {
    this.props.actions.initWelcomeMatStatus(this.props.name);
  }

  componentDidUpdate(prevProps) {
    if (this.props.welcomeMat.shouldOpen !== prevProps.welcomeMat.shouldOpen) {
      if (this.props.welcomeMat.shouldOpen) {
        this.props.actions.openModal(this.props.name);
      }
    }
  }

  handleClose() {
    this.props.actions.closeWelcomeMat(this.props.name);
  }

  render() {
    const { formatMessage } = this.props.intl;
    const regex = /[2,3,4]01/;
    const stackUrl = getStackUrl() || '';
    const displayResidencyBanner = !!stackUrl.match(regex) || false;
    const dataResidencyHelpLink =
      'https://help.salesforce.com/s/articleView?id=sf.mc_anb_data_residency_hyperforce.htm&type=5';
    const isOpen = this.props.modals[this.props.name]?.isOpen || false;

    const textFor = (tile, part, values) => (
      <FormattedMessage
        id={`components.experiment.welcomeMat.tiles.${tile}.${part}`}
        values={values}
      />
    );

    const tiles = [
      {
        id: 'create',
        iconName: 'edit_form',
        title: textFor('create', 'title'),
        description: textFor('create', 'description')
      },
      {
        id: 'use',
        iconName: 'email',
        title: textFor('use', 'title'),
        description: textFor('use', 'description')
      },
      {
        id: 'analyze',
        iconName: 'graph',
        title: textFor('analyze', 'title'),
        description: textFor('analyze', 'description')
      }
    ];

    const helpLink =
      'https://help.salesforce.com/s/articleView?id=sf.mc_pb_einstein_content_testing.htm&type=5';
    const tellMeMoreLink = (
      <a rel="noopener noreferrer" target="_blank" href={helpLink}>
        {this.props.intl.formatMessage({
          id: 'components.experiment.welcomeMat.tellMeMore'
        })}
      </a>
    );

    const billingLink = 'https://sfdc.co/mc-multipliers';
    const tellMeMoreBillingLink = (
      <a rel="noopener noreferrer" target="_blank" href={billingLink}>
        {this.props.intl.formatMessage({
          id: 'components.experiment.welcomeMat.tellMeMore'
        })}
      </a>
    );

    return (
      <WelcomeMat
        className="experiment-welcome-mat"
        labels={{
          title: formatMessage({
            id: 'components.experiment.welcomeMat.title'
          }),
          description: (
            <FormattedMessage
              id="components.experiment.welcomeMat.description"
              values={{ tellMeMoreLink }}
            />
          )
        }}
        doNotShowAgainCheckbox={
          <Checkbox
            assistiveText={{
              label: formatMessage({
                id: 'components.experiment.welcomeMat.dontShow'
              })
            }}
            id="dont-show"
            labels={{
              label: formatMessage({
                id: 'components.experiment.welcomeMat.dontShow'
              })
            }}
            onChange={() =>
              this.props.actions.updateWelcomeMat(
                !this.props.welcomeMat.shouldOpen,
                this.props.name
              )
            }
          />
        }
        onRenderInfoActions={() => (
          <Button
            key="welcomeMatSave"
            variant="brand"
            label={formatMessage({
              id: 'components.experiment.welcomeMat.getStarted'
            })}
            onClick={() => this.handleClose()}
          />
        )}
        isOpen={isOpen}
        onRequestClose={() => this.handleClose()}
        dismissOnClickingOutside={false}
        variant="info-only"
      >
        {displayResidencyBanner ? (
          <DataResidencyBanner>
            <FormattedMessage
              id={'components.ecs.setup.dataResidency'}
              values={{
                link: (
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={dataResidencyHelpLink}
                  >
                    {formatMessage({
                      id: 'components.ecs.setup.learnMore'
                    })}
                  </a>
                )
              }}
            />
          </DataResidencyBanner>
        ) : (
          <div></div>
        )}
        {tiles.map(tile => {
          return (
            <WelcomeMatTile
              key={tile.id}
              title={tile.title}
              description={tile.description}
              icon={
                <Icon
                  category={tile.iconCategory || 'utility'}
                  name={tile.iconName}
                />
              }
            />
          );
        })}
        <footer className="welcome-mat-footer">
          <FormattedMessage
            id="components.experiment.welcomeMat.footer"
            values={{ tellMeMoreBillingLink }}
          />
        </footer>
      </WelcomeMat>
    );
  }
}

ExperimentWelcomeMat.propTypes = {
  welcomeMat: PropTypes.shape({
    shouldOpen: PropTypes.bool
  }),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  name: PropTypes.string,
  modals: PropTypes.object,
  actions: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(ExperimentWelcomeMat);
